import { styled } from "styled-components";

export const StyledH1 = styled.h1`
  font-size: 2.5rem;
  color: #58585a;
  margin: 5px 0;
  @media (max-width: 768px) {
    text-align: center;
  }
`;
